module.exports = __webpack_public_path__ + "fonts/tt_sushkof_regular.708cf7d.woff2";